import { render, staticRenderFns } from "./QuestionsOrderInfo.vue?vue&type=template&id=0dd27c00&"
import script from "./QuestionsOrderInfo.vue?vue&type=script&lang=ts&"
export * from "./QuestionsOrderInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports